import {
  type TypedUseAction,
  type TypedUseSelector,
  useAction as _useAction,
  useSelector as _useSelector,
  useStore as _useStore,
} from 'react-unistore';

import type { Store, StoreState } from 'src/store/types';

export const useSelector: TypedUseSelector<StoreState> = _useSelector;
export const useAction: TypedUseAction<StoreState> = _useAction;
export const useStore = () => _useStore() as Store;
